export default __webpack_public_path__ + "static/resources/policy/Лесной_эталон_Сертификат.PDF";